import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { router } from "./routes";
import { ThemeProvider } from "./components/ThemeProvider";
import { EnvironmentIndicator } from "./components/EnvironmentIndicator";
import "./styles/globals.css";

console.log("[DEBUG] Iniciando aplicação");

const rootElement = document.getElementById("root");
console.log("[DEBUG] Elemento root:", rootElement);

if (!rootElement) {
  console.error("[ERROR] Elemento root não encontrado!");
  throw new Error("Elemento root não encontrado!");
}

const root = ReactDOM.createRoot(rootElement);
console.log("[DEBUG] Root criado");

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <RouterProvider router={router} />
        <EnvironmentIndicator />
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);

console.log("[DEBUG] Aplicação renderizada");
// Cache bust
